import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import { equipmentsTypeNames } from '../constants/equipmentsTypeNames';
import type { IHardwareOverviewDetails } from '../model/hardwareOverviewDetails';

interface IHardwareOverviewDetailsKeys {
  locationIds: string;
  searchValue: string;
}

export const hardwareOverviewDetailsKey = (locationIds?: Array<number>, searchValue?: string) => [
  'hardwareOverviewDetails',
  locationIds,
  searchValue,
];

export const hardwareOverviewDetailsFn = ({ queryKey }: QueryFunctionContext<string[]>) =>
  apiClient.get(`${APP_API_URL_V2}customer-dashboard-v2/hardware-overview/details`, {
    params: {
      search: queryKey[2] || undefined,
      locationIds: queryKey[1],
    },
  });

const hardwareOverviewDetailsSelect = ({ data }: AxiosResponse<{ data: IHardwareOverviewDetails }>) => {
  const equipments = data?.data || {};
  const equipmentsTypeKeys = Object.keys(equipmentsTypeNames) as Array<keyof typeof equipmentsTypeNames>;
  const equipmentsTypeList: (keyof typeof equipmentsTypeNames)[] = [];
  let equipmentsTotal = 0;

  equipmentsTypeKeys.forEach((equipmentType) => {
    const equipmentTypeTotal = equipments[`${equipmentType}_total`];

    if (equipmentTypeTotal) {
      equipmentsTotal += equipmentTypeTotal;
      equipmentsTypeList.push(equipmentType);
    }
  });

  return { equipments, equipmentsTypeList, equipmentsTotal };
};

export const useHardwareOverviewDetailsQuery = ({
  locationIds,
  searchValue,
}: IHardwareOverviewDetailsKeys) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: hardwareOverviewDetailsKey(locationIds, searchValue),
    queryFn: hardwareOverviewDetailsFn,
    enabled: !!locationIds && locationIds !== 'all',
    placeholderData: {
      data: {
        data: {
          equipments: {},
          equipmentsTypeList: [],
          equipmentsTotal: 0,
        },
      },
    },
    select: hardwareOverviewDetailsSelect,
  });
};
